import { TZDate } from '@date-fns/tz';

export class SubscriptionBannerModel {
  /**
   * Indicates wheather there's an active subscription.
   */
  public activeSubscriptionExistenceFlag: boolean;

  /**
   * CSS class applied to the subscription banner.
   */
  public cssClass: string;

  /**
   * indicates wheather to display the subscription banner.
   */
  public displayFlag: boolean;

  /**
   * The number of days left from now to the last active subscription end dated.
   */
  public lastActiveSubscriptionDaysLeft: number | null | undefined;

  /**
   * The last active subscription display label (ex: essai gratuit, ex: abonnement)
   */
  public lastActiveSubscriptionDisplayLabel: string;

  /**
   * End date of the current active subscription.
   */
  public lastSubscriptionEndDate: TZDate | null;

  public suspendedFlag: boolean | undefined;
}
